// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.zo35fd0 {
  max-width: 34%;
  flex: 0 1 34%;
  align-self: stretch;
}
.zo35fd1 {
  flex: 1 0 100%;
}
.zo35fd2 {
  cursor: pointer;
}
@media screen and (min-width: 768px) {
  .zo35fd0 {
    padding: var(--_18w76bwh) ;
  }
  .zo35fd1 {
    flex: 1 0 50%;
    min-height: 25rem;
  }
  .zo35fd2 {
    font-size: 1.0625rem;
  }
}`, "",{"version":3,"sources":["webpack://./../../node_modules/@vanilla-extract/webpack-plugin/extracted.js"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;AACA;EACE,eAAe;AACjB;AACA;EACE;IACE,0BAA0B;EAC5B;EACA;IACE,aAAa;IACb,iBAAiB;EACnB;EACA;IACE,oBAAoB;EACtB;AACF","sourcesContent":[".zo35fd0 {\n  max-width: 34%;\n  flex: 0 1 34%;\n  align-self: stretch;\n}\n.zo35fd1 {\n  flex: 1 0 100%;\n}\n.zo35fd2 {\n  cursor: pointer;\n}\n@media screen and (min-width: 768px) {\n  .zo35fd0 {\n    padding: var(--_18w76bwh) ;\n  }\n  .zo35fd1 {\n    flex: 1 0 50%;\n    min-height: 25rem;\n  }\n  .zo35fd2 {\n    font-size: 1.0625rem;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
